import { Feature } from '@tencent/workbench';
import BaseDrawerFeature from '@framework/workbench/common/feature/base-drawer-feature';
import { IMultiplyModel } from '@src/slide/domain/ui-model/element-modeles/Interface/multiply-model.interface';
import {
    IElementBaseModel,
} from '@src/slide/domain/ui-model/element-modeles/Interface/base/element-base-model.interface';
import { IEmptyModel } from '@src/slide/domain/ui-model/element-modeles/Interface/empty-model.interface';
import { checkIsSlideBg } from '@framework/workbench/drawer/utils';
import { FillType, FillTypeMap } from '@framework/workbench/drawer/ui/fill/constants';
import {
    IBackgroundFillInfo,
    IBaseFillInfo,
} from '@src/slide/domain/ui-model/element-modeles/property/fill/fill.interface';
import { ISolidFillProperty } from '@src/slide/domain/ui-model/element-modeles/property/fill/solid-fill';
import { SolidFill as SolidFillColor } from '@src/slide/domain/ui-model/plugin/referModels/FillClass';
import { TDColor } from '@src/slide/domain/ui-model/element-modeles/property/color/td-color';
import { STSchemeColorVal } from '@tencent/slide-sdk-pb-model';

@Feature()
export class BaseFillFeature extends BaseDrawerFeature {
    public constructor() {
        super();
    }

    protected get isSlideBg(): boolean {
        return checkIsSlideBg(this.getPropertyMenu()?.items);
    }

    protected get fillType(): string {
        const type = (this.getSelectModel() as IMultiplyModel | IElementBaseModel | IEmptyModel)?.getBackgroundFill?.()
            ?.getFillType();
        return type ? FillTypeMap[type] : FillType.NO_SELECT;
    }

    protected get fillInfo(): IBaseFillInfo | null {
        const fill = ((this.getSelectModel() as IMultiplyModel | IElementBaseModel | IEmptyModel)
            ?.getBackgroundFill?.()?.getCurrentFill() as ISolidFillProperty);
        return fill?.fillInfo;
    }

    protected get fillColor(): IBackgroundFillInfo {
        const fillColor = this.getSelectModel()?.getBackgroundFill?.()
            .getFillInfo();
        return fillColor ? fillColor : this.getDefaultValue();
    }

    public updateFillProps(value, onlyChangeUI?) {
        (this.getSelectModel() as IMultiplyModel | IElementBaseModel | IEmptyModel).getBackgroundFill?.()
            .updateCurrentFill(value, onlyChangeUI);
    }

    private getDefaultValue = (): IBackgroundFillInfo => {
        const isMultiOrGroup = this.isMultiOrGroup();
        if (isMultiOrGroup || this.isTable()) {
            return {};
        }
        if (this.isSlideBg) {
            return { solidFill: new SolidFillColor(new TDColor({ themeKey: STSchemeColorVal.bg1 })) };
        }
        return { noFill: 1 };
    };
}
